import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GoalsKeys } from "web_myplann/Api/Goals/GoalsKeys";
import { deleteFuturePortfoliosIdV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

type DeleteFuturePortfolioInput = {
	id: number;
	goalId: number;
};

export const useFuturePortfolioDeleteMutation = () => {
	const queryClient = useQueryClient();

	return useMutation<void, Error, DeleteFuturePortfolioInput>({
		mutationFn: processResponse(({ id }: DeleteFuturePortfolioInput) =>
			deleteFuturePortfoliosIdV2(id),
		),
		onSuccess: (_data, { goalId }) =>
			queryClient.invalidateQueries({
				queryKey: GoalsKeys.detail(goalId),
			}),
	});
};
